module.exports = __webpack_public_path__ + "img/4.69bc3ec9.png";